// slices/activity/thunk.ts

import { createAsyncThunk } from "@reduxjs/toolkit";
// import { API_URL } from "src/helpers/api_url"; // Adjust path as necessary
import { OrderAndSalesAxios } from "../../api/orderandsalesaxios"

// --- Interfaces for Request/Response Data ---

// Used for fetching the list
interface FetchParams {
    id: string; // The enquiry_id (UUID)
    targetType: "enquiry" | "quotation" | "sales_order" | "payment_management"; // The enquiry_type (string)
    type: string

}

// Data structure expected for a single assigned member from the backend
// interface AssignedMemberResponse {
//     id: string; // The assignment record ID (UUID)
//     user: string; // The user ID
//     user_name: string; // The user's name
//     initials: string; // Calculated initials
//     bg: string; // Display color
//     color: string; // Display text color
//     // ... potentially other fields
// }

// Data needed to create a new assignment (POST request)
interface AssignMemberParams {
    targetType: string;
    user: {
        action: string;
        user_id: string;
        [key: string]: any;
        // Accepts dynamic keys like enquiry_enquiry, quotation_quotation, etc.
    };
}

// Data needed to remove an assignment (DELETE request)
// interface RemoveMemberParams extends FetchParams {
//     user :{
//         id:string
//     }

// }

// =========================================================================
// 1. Fetch Assigned Members List (GET)
// Endpoint: assigned-to/<str:enquiry_type>/<uuid:enquiry_id>/
// =========================================================================

export const fetchAssignedMembers = createAsyncThunk(
    "activity/fetchAssignedMembers",
    async ({ id, targetType, type }: FetchParams, { rejectWithValue }) => {
        try {
            const url = `/${targetType}/assigned-to/${type}/${id}/`;
            const response = await OrderAndSalesAxios.get(url);
            // The thunk should return the payload that will update the state
            return response.data;
        } catch (error) {
            // Use OrderAndSaesAxios specific error handling if possible
            // if (OrderAndSaesAxios.isAxiosError(error) && error.response) {
            //     return rejectWithValue(error.response.data);
            // }
            return rejectWithValue("Failed to fetch assigned members.");
        }
    }
);

// =========================================================================
// 2. Assign a New Member (POST)
// We assume assignment creation uses POST to the LIST endpoint.
// Endpoint: assigned-to/<str:enquiry_type>/<uuid:enquiry_id>/
// Payload: { user: userId }
// =========================================================================

export const assignMemberToTarget = createAsyncThunk(
    "activity/assignMemberToTarget",
    async ({ targetType, user }: AssignMemberParams, { rejectWithValue }) => {
        try {
            const url = `/${targetType}/assigned-to/`;
            // Send the user object as the payload
            const response = await OrderAndSalesAxios.put(url, user);
            return response.data; // Return the new assignment record
        } catch (error) {
            return rejectWithValue("Failed to assign member.");
        }
    }
);

// =========================================================================
// 3. Remove a Member Assignment (DELETE)
// Endpoint: assigned-to/<uuid:id>/
// =========================================================================

export const removeMemberFromTarget = createAsyncThunk(
    "activity/removeMemberFromTarget",
    async ({ targetType, user }: AssignMemberParams, { rejectWithValue }) => {
        try {
            const url = `/${targetType}/assigned-to/`;
            // Send the user object as the payload
            const response = await OrderAndSalesAxios.put(url, user);
            return response.data; // Return the new assignment record
        } catch (error) {
            return rejectWithValue("Failed to assign member.");
        }
    }
);
